import { render } from "./SVGDelete.vue?vue&type=template&id=72212b60"
import script from "./SVGDelete.vue?vue&type=script&lang=js"
export * from "./SVGDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__